<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="title">欢迎加入XD</div>
      <div class="desc">现金红包每天更新，团队奖励上不封顶</div>
      <div class="btn-middle flamingo receive" @click="handler">开始领红包</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 187px;
    padding: 30px 0;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .desc {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .receive {
      margin: 0 auto;
    }
  }
</style>
<script>
  import Dialog from 'components/Dialog'
  export default {
    components: {
      Dialog
    },
    props: {
      handler: Function
    },
    methods: {
      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
      }
    }
  }
</script>
